module.exports = __webpack_public_path__ + "img/security.6747d2b.svg";